<customer-portal-app-navbar></customer-portal-app-navbar>
<customer-portal-app-navbar-second></customer-portal-app-navbar-second>
@if (hasTestView) {
  <customer-portal-app-test></customer-portal-app-test>
}
@if (!hasTestView) {
  <div class="w-full h-[500px] flex justify-center items-center">
    <div class="text-red-700 font-black text-7xl">403</div>
  </div>
}
<customer-portal-footer-container></customer-portal-footer-container>
